<script lang="ts" setup>
const site = useAppConfig().site

const footerSocials = computed(() => {
  const out: Record<string, { label: string, href: string }> = {}
  if (site.footer?.email) {
    out.email = {
      label: `Email ${site.footer.email}`,
      href: `mailto:${site.footer.email}`,
    }
  }
  return { ...out, ...site.socials }
})

const hasFooterSocials = computed(() => Object.keys(footerSocials.value).length > 0)

const COPYRIGHT_SINCE = 2023
const copyrightYears = computed(() => {
  const y = new Date().getFullYear()
  return y <= COPYRIGHT_SINCE ? String(COPYRIGHT_SINCE) : `${COPYRIGHT_SINCE}–${y}`
})
</script>

<template>
  <footer
    class="mt-24 flex flex-col items-center gap-6 py-8 md:min-h-[9rem]"
    :class="{
      'items-start': site.footer.alignment === 'left',
      'items-end': site.footer.alignment === 'right',
    }"
  >
    <NuxtLink
      v-if="site.footer?.credits?.enabled && site.footer.credits.repository"
      :to="site.footer.credits.repository"
      class="text-3xl font-bold mb-2"
    >
      {{ site.footer.credits.text }}
    </NuxtLink>

    <div
      v-if="site.footer.navigation"
      class="hidden sm:flex mb-8"
    >
      <MainNav />
    </div>

    <p
      v-if="site.footer?.message"
      class="text-center text-gray-600 dark:text-gray-400 mb-2"
    >
      {{ site.footer.message }}
    </p>

    <div class="grid grid-cols-12 w-full gap-4 max-w-4xl">
      <div
        v-if="hasFooterSocials"
        class="col-span-12 flex justify-center gap-4 xs:col-span-4 xs:col-start-5"
      >
        <SocialIcons :socials="footerSocials" />
      </div>
      <div class="col-span-12 flex justify-center xs:col-span-2 xs:col-start-11 xs:justify-end">
        <ThemeToggle />
      </div>
    </div>

    <p class="text-center text-sm text-gray-500 dark:text-gray-500">
      © {{ copyrightYears }} Ahmed Bassell
    </p>
  </footer>
</template>
